import { ca } from '@cian/analytics';

const CATEGORY = 'Filters';
/** У события про изменение фильтров на пустой выдаче своя категория — она общая с картой */
const LISTING_CATEGORY = 'Listing';

/**
 * Снятие одного тега в блоке пустой выдачи.
 *
 * @param label параметры запроса, которые сняло это действие
 * @param count сколько объявлений было обещано на кнопке, по которой кликнул пользователь
 */
export function trackTagsClear(label: string, count: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: CATEGORY,
    action: 'filter_tips_clear',
    label,
    useLastProducts: true,
    page: {
      extra: { is_empty: true, count },
    },
  });
}

/**
 * Сброс всех тегов в блоке пустой выдачи.
 *
 * @param label параметры запроса, которые сняло это действие
 */
export function trackAllTagsClear(label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: CATEGORY,
    action: 'filter_tips_all_clear',
    label,
    useLastProducts: true,
    page: {
      extra: { is_empty: true },
    },
  });
}

/**
 * Клик на изменение фильтров при пустой выдаче. Событие общее с картой, поэтому категория
 * `Listing`, а не `Filters`, как у событий по тегам.
 */
export function trackChangeFiltersClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: LISTING_CATEGORY,
    action: 'click_empty_list',
    label: 'change',
  });
}

/**
 * Показ блока пустой выдачи. Отправляется один раз, когда блок попал во вьюпорт.
 */
export function trackEmptyStateShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: CATEGORY,
    action: 'show_block',
    label: 'filter_tips_empty',
  });
}
